import { STORY_PLATFORM_TYPES } from '../../constants';

export const STORY_MEDIA_RESTRICTIONS = {
  DISABLE_CUSTOM_UPLOAD: false,
  DISABLE_CUSTOM_DROP: false,
  SINGLE_SELECTION_ONLY: false,
};

export const STORY_FORM_FIELDS = {
  MEDIA: 'media',
  MESSAGE: 'message',

  [STORY_PLATFORM_TYPES.LINKEDIN]: STORY_PLATFORM_TYPES.LINKEDIN,
  [STORY_PLATFORM_TYPES.YOUTUBE]: STORY_PLATFORM_TYPES.YOUTUBE,
  [STORY_PLATFORM_TYPES.META]: STORY_PLATFORM_TYPES.META,
  [STORY_PLATFORM_TYPES.BANNERS]: STORY_PLATFORM_TYPES.BANNERS,
  [STORY_PLATFORM_TYPES.OTHER_SOCIALS]: STORY_PLATFORM_TYPES.OTHER_SOCIALS,
  [STORY_PLATFORM_TYPES.LONG_FORM]: STORY_PLATFORM_TYPES.LONG_FORM,
};
